import {
  Col,
  Row,
  Space,
  Table,
  Tag,
  DatePicker,
  Card,
  Button,
  message,
  Spin,
  Select,
  Tooltip,
  Typography,
  Input,
} from "antd";
import Search from "antd/es/input/Search";
import React, { useEffect, useMemo, useState } from "react";
import DetailModal from "../detail/DetailModal";
import {
  EditOutlined,
  SyncOutlined,
  FormOutlined,
  SearchOutlined,
  ReloadOutlined,
  UpSquareOutlined,
  DownSquareOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import MotionHoc from "../../../utils/MotionHoc";
import { Link } from "react-router-dom";
import {
  baseUrl,
  GET_JOB_IN_PROGRESS_BY_STATUS,
  HEADERS_EXPORT,
} from "../../API/apiUrls";

import axios from "axios";
import { INDICT } from "../../../utils/constant/StatusConstant";
import DateCustom from "../../../hook/DateCustom";
import CreateDocument from "./modal/CreateDocument";
import DocumentEnforce from "./modal/DocumentEnforce";
import UpdateStatusBlackNumber from "./modal/UpdateStatusBlackNumber";
import EditFrom from "./modal/EditForm";
import dayjs from "dayjs";
import EditUpdateStatusBlackNumber from "./modal/EditUpdateStatusBlackNumber";
import { optionsLone } from "../../../utils/constant/LoanTypeConstant";
import { optionsLocat } from "../../../utils/constant/LocatOption";
import utc from "dayjs/plugin/utc";
import { ThaiRangePicker } from "../../../hook/ThaiDatePickerNew";
dayjs.extend(utc);

const Main = () => {
  const [
    convertDateThai,
    convertDateThaiShort,
    convertDateThaiYear,
    convertDateThaiMonth,
    convertDateThaiDate,
    dateNow,
  ] = DateCustom();
  const { Option } = Select;
  const userCompany = localStorage.getItem("COMPANY_ID");
  const ROLE_ID = localStorage.getItem("ROLE_ID");
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const [isModal, setIsModal] = useState(false);
  const [isModalCreate, setIsModalCreate] = useState(false);
  const [isModalDocument, setIsModalDocument] = useState(false);
  const [isModalUpdate, setIsModalUpdate] = useState(false);
  const [isModalEdit, setIsModalEdit] = useState(false);
  const [isModalEditUpdate, setIsModalEditUpdate] = useState(false);
  const [arrayTable, setArrayTable] = useState();
  const [dataArr, setDataArr] = useState();
  const { RangePicker } = DatePicker;
  const [loading, setLoading] = useState();
  const [dataModal, setDataModal] = useState();
  const [tableLength, setTableLength] = useState(0);
  const [dataRecord, setDataRecord] = useState();
  const [searchEdit, setSearchEdit] = useState(null);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [statusId, setStatusId] = useState();
  const [datePickerImport, setDatePickerImport] = useState();
  const [datePickerConsderation, setDatePickerConsderation] = useState();
  const [searchInput, setSearchInput] = useState();
  const [arrow, setArrow] = useState("Show");
  const [advanceSearch, setAdvanceSearch] = useState(false);
  const [datePickerJudge, setDatePickerJudge] = useState();
  const toggle = () => setAdvanceSearch((v) => !v);

  useEffect(() => {
    loadData();
  }, []);

  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") {
      return false;
    }
    if (arrow === "Show") {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, [arrow]);

  const renderOpteionStatus = () => {
    return (
      <>
        <Option value={4}>
          <span style={{ marginRight: 8 }}>🗂️</span>
          ทั้งหมด
        </Option>
        <Option value={1}>
          <CloseCircleOutlined style={{ color: "red", marginRight: 8 }} />
          ไม่มีวันนัดศาล
        </Option>
        <Option value={2}>✅ มีวันนัดศาลแล้ว</Option>
        <Option value={3}>⚡ พิพากษาแล้ว</Option>
      </>
    );
  };

  const onExpand = (expanded, record) => {
    if (expanded) {
      // เมื่อแถวถูกขยาย, ให้เพิ่ม key ของแถวนั้นลงใน expandedRowKeys
      setExpandedRowKeys([record.key]);
    } else {
      // เมื่อแถวถูกยุบ, ให้ลบ key ของแถวนั้นออกจาก expandedRowKeys
      setExpandedRowKeys([]);
    }
  };

  const loadData = async (data) => {
    setLoading(true);
    console.log(data);

    //  baseUrl + GET_JOB_IN_PROGRESS_BY_STATUS + INDICT,
    // "http://localhost:8080/lawyer/dev/api/jobs/" + INDICT,

    try {
      const response = await axios.get(
        baseUrl +
          GET_JOB_IN_PROGRESS_BY_STATUS +
          INDICT +
          (userId === 1 ? "" : "?user_id=" + userId),
        {
          headers: HEADERS_EXPORT,
        },
      );
      if (response.data) {
        let i = 1;
        if (response.data) {
          const newData = response.data.map((item) => ({
            ...item,
            key: i++,
          }));
          filterData(newData);
          console.log(newData);

          setLoading(false);
        }
      } else {
        setArrayTable([]);
      }
    } catch (error) {
      console.error(
        "Error posting data:",
        error.response ? error.response.data : error.message,
      );
      setLoading(false);
      message.error(`ไม่พบข้อมูล: ${error.message}`);
    }
  };

  const filterData = (data) => {
    if (Array.isArray(data)) {
      let filteredData;

      if (userCompany === "3") {
        filteredData = data.filter((item) => {
          const branch = item.LOCAT;
          // ถ้า branch เป็น null หรือ undefined ให้ return true ไปเลย (หรือ false ก็ได้ ขึ้นกับความต้องการ)
          if (!branch) return true; // หรือ false ก็ได้ ถ้าอยาก "กรองออก"

          // ถ้า branch มีค่า → เช็กตามปกติ
          return (
            !optionsLocat.some((opt) => branch.includes(opt.label)) ||
            item.CONTNO.includes("UD")
          );
        });
      } else {
        filteredData = data.filter((item) => {
          const branch = item.LOCAT;
          if (!branch) return false; // ไม่มี branch ไม่ผ่านเงื่อนไข

          return optionsLocat.some((opt) => branch.includes(opt.label));
        });
      }

      const newData = filteredData.filter(
        (item) =>
          item.LAWYER_ID === userId || ROLE_ID === "1" || ROLE_ID === "2",
      );

      const newDataShow = filteredData.filter(
        (item) =>
          (item.LAWYER_ID === userId || ROLE_ID === "1" || ROLE_ID === "2") &&
          item.MAIN_STATUS_ID === item.STATUS_ID,
      );
      setSearchEdit(newData);
      setArrayTable(newDataShow);
      setDataArr(newData);
      setTableLength(newDataShow.length);
      console.log("newData", newData);
      console.log("Length of filtered data:", newData.length);
    } else {
      console.error("data is not an array or is undefined");
      setTableLength(0);
    }
  };

  const search = (event) => {
    console.log("query--->", event.target.value);
    setSearchInput(event.target.value);
  };

  const handleUpdateData = (data) => {
    console.log("data---->update", data);
    if (data !== 0) {
      const result = dataArr.map((item) => {
        if (item.id === data.id) {
          return { ...data };
        } else {
          return { ...item };
        }
      });
      console.log(result);
      setDataArr(result);
      const arr = result.filter(
        (item) =>
          (item.LAWYER_ID === userId || ROLE_ID === "1" || ROLE_ID === "2") &&
          item.MAIN_STATUS_ID === item.STATUS_ID,
      );
      console.log("arr", arr);
      setArrayTable(arr);
    } else {
      loadData();
      console.log("handleUpdateData loadData");
    }
  };

  const renderDate = (record) => {
    //ส่งค่า null ออกไปถ้า record นี่ยังไม่มี
    if (!record.DATE) {
      return null;
    }
    let color;
    const recordDate = dayjs.utc(record.DATE).startOf("day");
    const today = dayjs.utc().startOf("day");

    // คำนวณความแตกต่างในหน่วยปี
    const yearsDifference = today.diff(recordDate, "year");

    // คำนวณความแตกต่างในหน่วยเดือน
    const monthsDifference = today.diff(recordDate, "month");

    // คำนวณความแตกต่างในหน่วยวัน
    const daysDifference = today.diff(recordDate, "day");

    // คำนวณส่วนที่เหลือหลังจากคำนวณปีแล้ว (คำนวณเดือนที่เหลือ)
    const remainingMonths = today
      .subtract(yearsDifference, "year")
      .diff(recordDate, "month");

    // คำนวณส่วนที่เหลือหลังจากคำนวณปีและเดือนแล้ว (คำนวณวันที่เหลือ)
    const remainingDays = today.diff(recordDate, "day");

    color =
      record.MAIN_STATUS_ID !== record.STATUS_ID && record.PROCESS_ID === 3
        ? "green"
        : record.MAIN_STATUS_ID === record.STATUS_ID && record.PROCESS_ID === 3
          ? "blue"
          : "red";

    const formattedDate = record.DATE ? convertDateThai(recordDate) : null;
    return (
      <Tag color={color} key={daysDifference} style={{ textAlign: "center" }}>
        {formattedDate}
        <br />
        {(record.MAIN_STATUS_ID === record.STATUS_ID &&
          record.PROCESS_ID === 3) ||
        record.PROCESS_ID === 1 ? (
          <span>
            {record.LOAN_TYPE_ID === 1 && remainingDays > 30
              ? "เกิน"
              : record.LOAN_TYPE_ID === 2 && remainingDays > 60
                ? "เกิน"
                : null}{" "}
            {remainingDays} วัน
          </span>
        ) : null}
      </Tag>
    );
  };

  const renderLoanType = (value) => {
    return (
      optionsLone.find((item) => item.value === value)?.label || "ไม่พบชื่อ"
    );
  };

  const onChangeJudgeDate = (dates) => {
    setDatePickerJudge(dates);
    setDatePickerConsderation(null); // เคลียร์อีกอัน
    setDatePickerImport(null);
  };

  const onChangeConsderationDate = (dates) => {
    setDatePickerJudge(null);
    setDatePickerConsderation(dates); // เคลียร์อีกอัน
    setDatePickerImport(null);
  };

  const onChangeImportDate = (dates) => {
    setDatePickerJudge(null);
    setDatePickerConsderation(null); // เคลียร์อีกอัน
    setDatePickerImport(dates);
  };

  const onChangeSelectStatus = (value) => {
    console.log("onChangeSelectStatus-->", value);
    // onSearchStatus(value);
    setStatusId(value);
  };

  const onQueryData = () => {
    let result = [];

    if (
      !searchInput &&
      !statusId &&
      !datePickerImport &&
      !datePickerConsderation &&
      !datePickerJudge
    ) {
      result = dataArr.filter(
        (item) =>
          (item.LAWYER_ID === userId || ROLE_ID === "1" || ROLE_ID === "2") &&
          item.MAIN_STATUS_ID === item.STATUS_ID,
      );
    } else {
      result = [...dataArr];
    }

    console.log(result);

    // filter จาก input
    if (searchInput && searchInput.trim() !== "") {
      result = result.filter(
        (item) =>
          item?.CONTNO?.includes(searchInput.trim()) ||
          item?.CUSTOMER_LNAME?.includes(searchInput.trim()) ||
          item?.CUSTOMER_FNAME?.includes(searchInput.trim()),
      );
    }

    // filter จาก select (statusId)
    if (statusId) {
      if (statusId === 1) {
        result = result.filter(
          (item) => !item.consideration_date && !item.black_case_number,
        );
      } else if (statusId === 2) {
        result = result.filter(
          (item) => item.consideration_date && item.black_case_number,
        );
      } else if (statusId === 3) {
        result = result.filter(
          (item) => item.judge_date && item.red_case_number,
        );
      }
    }

    // filter จาก date (เลือกได้ทีละอัน)
    if (datePickerJudge && datePickerJudge.length === 2) {
      const start = dayjs(datePickerJudge[0]).startOf("day").valueOf();
      const end = dayjs(datePickerJudge[1]).endOf("day").valueOf();

      result = result.filter((item) => {
        const date = dayjs(item.judge_date).valueOf();
        return date >= start && date <= end;
      });
    } else if (datePickerConsderation && datePickerConsderation.length === 2) {
      const start = dayjs(datePickerConsderation[0]).startOf("day").valueOf();
      const end = dayjs(datePickerConsderation[1]).endOf("day").valueOf();

      result = result.filter((item) => {
        const date = dayjs(item.consideration_date).valueOf();
        return date >= start && date <= end;
      });
    } else if (datePickerImport && datePickerImport.length === 2) {
      const start = dayjs(datePickerImport[0]).startOf("day").valueOf();
      const end = dayjs(datePickerImport[1]).endOf("day").valueOf();

      result = result.filter((item) => {
        const date = dayjs(item.DATE).valueOf();
        return date >= start && date <= end;
      });
    }

    if (result.length > 0) {
      setArrayTable(result);
      setTableLength(result.length);
    } else {
      message.error("ไม่พบข้อมูล");
      setArrayTable(result);
      setTableLength(result.length);
    }
  };

  const columns = [
    {
      title: "ลำดับ",
      dataIndex: "key",
      key: "key",
      align: "center",
      width: "10%",
      render: (text, object, key) => key + 1,
      sorter: {
        compare: (a, b) => a.key - b.key,
        multiple: 5,
      },
    },
    {
      title: "เลขที่สัญญา",
      dataIndex: "CONTNO",
      key: "CONTNO",
      align: "center",
      render: (text, record) => (
        <Link
          onClick={() => {
            setIsModal(true);
            setDataRecord(record);
          }}
        >
          {record.CONTNO ? record.CONTNO : null}
        </Link>
      ),
    },
    {
      title: "ชื่อ-นามสกุล",
      dataIndex: "CUSTOMER_TNAM",
      key: "CUSTOMER_TNAM",
      align: "center",
      render: (text, record) => (
        <>
          {record.CUSTOMER_TNAME ? record.CUSTOMER_TNAME : null}{" "}
          {record.CUSTOMER_FNAME ? record.CUSTOMER_FNAME : null}{" "}
          {record.CUSTOMER_LNAME ? record.CUSTOMER_LNAME : null}
        </>
      ),
    },
    {
      title: "ประเภทสัญญา",
      align: "center",
      render: (record) => <>{renderLoanType(record.LOAN_TYPE_ID)} </>,
    },
    {
      title: "วันที่นำเข้าส่วนฟ้อง",
      align: "center",
      render: (record) => <>{renderDate(record)}</>,
      sorter: (a, b) => {
        // เปรียบเทียบวันที่ระหว่าง a.DATE และ b.DATE
        return dayjs(b.DATE).isBefore(a.DATE) ? -1 : 1;
      },
      defaultSortOrder: "ascend", // ตั้งค่าเริ่มต้นเป็น "ascend"
    },
    {
      title: "วันนัดศาล",
      align: "center",
      render: (record) => (
        <>
          {record.consideration_date ? (
            <Tag color={"green"} style={{ textAlign: "center" }}>
              {dayjs(record.consideration_date)
                .add(543, "year")
                .format("D MMMM YY")}
            </Tag>
          ) : (
            "-"
          )}
        </>
      ),
      sorter: (a, b) => {
        // เปรียบเทียบวันที่ระหว่าง a.DATE และ b.DATE
        return dayjs(b.DATE).isBefore(a.DATE) ? -1 : 1;
      },
      defaultSortOrder: "ascend", // ตั้งค่าเริ่มต้นเป็น "ascend"
    },
    {
      title: "วันพิพากษา",
      align: "center",
      render: (record) => (
        <>
          {record.judge_date ? (
            <Tag color={"green"} style={{ textAlign: "center" }}>
              {record.red_case_number}
              <br />
              {dayjs(record.judge_date).add(543, "year").format("D MMMM YY")}
            </Tag>
          ) : (
            "-"
          )}
        </>
      ),
      sorter: (a, b) => {
        // เปรียบเทียบวันที่ระหว่าง a.DATE และ b.DATE
        return dayjs(b.DATE).isBefore(a.DATE) ? -1 : 1;
      },
      defaultSortOrder: "ascend", // ตั้งค่าเริ่มต้นเป็น "ascend"
    },
    ...(ROLE_ID === "1" || ROLE_ID === "2"
      ? [
          {
            title: "เจ้าของคดี",
            align: "center",
            render: (record) => <>{record?.LAWYER_NNAME}</>,
          },
        ]
      : []),
  ];

  return (
    <>
      <Card>
        <Row>
          <Col span={"12"} style={{ textAlign: "start", marginBottom: "10px" }}>
            <Input
              placeholder="ค้นหาสัญญา"
              onChange={search}
              style={{
                width: 200,
                marginRight: 10,
              }}
              value={searchInput}
              size="large"
            />
            <Select
              placeholder="เลือกสถานะ"
              optionFilterProp="value"
              popupMatchSelectWidth={false}
              onChange={(value) => onChangeSelectStatus(value)}
              style={{
                width: "auto",
              }}
              size="large"
              value={statusId}
            >
              {renderOpteionStatus()}
            </Select>
          </Col>
          <Col span={"12"} style={{ textAlign: "end", marginBottom: "10px" }}>
            <Space direction="horizontal" size={8}>
              <Tooltip
                title={advanceSearch ? "ซ่อนตัวกรอง" : "แสดงตัวกรอง"}
                arrow={mergedArrow}
              >
                {!advanceSearch ? (
                  <DownSquareOutlined
                    style={{ fontSize: 20, color: "blue", marginTop: 4 }}
                    onClick={toggle} // antd ส่งค่า checked มาให้
                  />
                ) : (
                  <UpSquareOutlined
                    style={{ fontSize: 20, color: "blue", marginTop: 4 }}
                    onClick={toggle} // antd ส่งค่า checked มาให้
                  />
                )}
              </Tooltip>
              <Button
                icon={<ReloadOutlined />}
                onClick={() => {
                  setSearchInput(null);
                  setStatusId(null);
                  setDatePickerImport(null);
                  setDatePickerConsderation(null);
                  setDatePickerJudge(null);
                }}
                style={{
                  color: "red",
                  borderRadius: "8px",
                  fontWeight: "bold",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                }}
              >
                ล้าง
              </Button>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                size="large"
                style={{
                  borderRadius: "8px",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  fontWeight: "bold",
                  background: "linear-gradient(135deg, #667eea, blue)",
                  border: "none",
                }}
                onClick={onQueryData}
                loading={loading}
              >
                ค้นหา
              </Button>
            </Space>
          </Col>
          <Col>
            {advanceSearch ? (
              <Col span={24} style={{ textAlign: "start" }}>
                <Space
                  direction="vertical"
                  size={8}
                  style={{ marginRight: 10 }}
                >
                  <Typography.Text strong>ค้นหาจากวันรับงาน</Typography.Text>

                  <ThaiRangePicker
                    value={datePickerImport}
                    onChange={onChangeImportDate}
                    size="large"
                  />
                </Space>

                <Space
                  direction="vertical"
                  size={8}
                  style={{ marginRight: 10 }}
                >
                  <Typography.Text strong>ค้นหาจากวันนัดศาล</Typography.Text>
                  <ThaiRangePicker
                    value={datePickerConsderation}
                    onChange={onChangeConsderationDate}
                    size="large"
                  />
                </Space>
                <Space direction="vertical" size={8}>
                  <Typography.Text strong>วันที่พิพากษา</Typography.Text>
                  <ThaiRangePicker
                    value={datePickerJudge}
                    onChange={onChangeJudgeDate}
                    size="large"
                  />
                </Space>
              </Col>
            ) : null}
          </Col>
        </Row>
      </Card>
      <Card>
        <Spin spinning={loading} size="large" tip=" Loading... ">
          <Row>
            <Col span={"24"}>
              <Table
                size="small"
                columns={columns}
                dataSource={arrayTable}
                scroll={{ x: 850 }}
                footer={() => <p>จำนวนสัญญาทั้งหมด {tableLength}</p>}
                expandable={{
                  expandedRowRender: (record) => (
                    <p style={{ margin: 0 }}>
                      {record.PROCESS_ID === 1 && userCompany === "3" ? (
                        <Button
                          name="create"
                          style={{
                            boxShadow: "0 4px 3px",
                            marginRight: "10px",
                          }}
                          onClick={() => {
                            setIsModalCreate(true);
                            setDataModal(record);
                          }}
                        >
                          <FormOutlined
                            style={{ color: "blue", fontSize: "16px" }}
                          />
                        </Button>
                      ) : record.PROCESS_ID === 3 ? (
                        <>
                          <Button
                            name="edit"
                            style={{
                              boxShadow: "0 4px 3px",
                              marginRight: "10px",
                            }}
                            onClick={() => {
                              setIsModalEdit(true);
                              setDataModal(record);
                            }}
                          >
                            <EditOutlined
                              style={{ color: "orange", fontSize: "16px" }}
                            />
                          </Button>
                        </>
                      ) : null}
                      {record.MAIN_STATUS_ID !== record.STATUS_ID &&
                      record.PROCESS_ID === 3 ? (
                        <Button
                          name="EditupdateStatus"
                          style={{ boxShadow: "0 4px 3px" }}
                          onClick={() => {
                            setIsModalEditUpdate(true);
                            setDataModal(record);
                          }}
                        >
                          <SyncOutlined
                            style={{ color: "orange", fontSize: "16px" }}
                          />
                        </Button>
                      ) : record.MAIN_STATUS_ID === record.STATUS_ID &&
                        record.PROCESS_ID === 3 ? (
                        <Button
                          name="updateStatus"
                          style={{ boxShadow: "0 4px 3px" }}
                          onClick={() => {
                            setIsModalUpdate(true);
                            setDataModal(record);
                          }}
                        >
                          <SyncOutlined
                            style={{ color: "green", fontSize: "16px" }}
                          />
                        </Button>
                      ) : null}

                      {/* <Button
                        name="document"
                        style={{ boxShadow: "0 4px 3px" }}
                        // onClick={() => {}}
                      >
                        <FilePdfOutlined
                          style={{ color: "orange", fontSize: "16px" }}
                        />
                      </Button> */}
                    </p>
                  ),
                  rowExpandable: (record) => userId === record.LAWYER_ID,
                  expandedRowKeys, // เก็บ state ของ row ที่ขยาย
                  onExpand, // ฟังก์ชันที่ควบคุมการขยาย
                }}
                rowKey="key"
              />
            </Col>
          </Row>
        </Spin>
      </Card>
      {isModal ? (
        <DetailModal open={isModal} close={setIsModal} dataRec={dataRecord} />
      ) : null}
      {isModalCreate ? (
        <CreateDocument
          open={isModalCreate}
          close={setIsModalCreate}
          dataDefault={dataModal}
          funcUpdateStatus={handleUpdateData}
        />
      ) : null}
      {isModalDocument ? (
        <DocumentEnforce open={isModalDocument} close={setIsModalDocument} />
      ) : null}
      {isModalUpdate ? (
        <UpdateStatusBlackNumber
          open={isModalUpdate}
          close={setIsModalUpdate}
          dataDefault={dataModal}
          funcUpdateStatus={handleUpdateData}
        />
      ) : null}
      {isModalEditUpdate ? (
        <EditUpdateStatusBlackNumber
          open={isModalEditUpdate}
          close={setIsModalEditUpdate}
          dataDefault={dataModal}
          funcUpdateStatus={handleUpdateData}
        />
      ) : null}
      {isModalEdit ? (
        <EditFrom
          open={isModalEdit}
          close={setIsModalEdit}
          dataDefault={dataModal}
          funcUpdateStatus={handleUpdateData}
        />
      ) : null}
    </>
  );
};

const PreLawsuitFiled = MotionHoc(Main);
export default PreLawsuitFiled;
